import { Component, Input, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/http/user/user.service';
import { ActivatedRoute } from '@angular/router';
import { MenuItem } from 'src/app/model/menu-item/menuIItem';
import { AllMenu } from 'src/app/model/menu-item/existingItems';
import { User } from 'src/app/model/users/users';
import { WebConfigurationService } from 'src/app/services/http/common/web-configuration.service';


@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  @Input() logged!: boolean;
  
  username !: string;
  currentDate : Date = new Date();
  title = 'GMAO';
  bClick = false;

  public restricted! : boolean;
  public showitem: boolean = true;

  constructor(private userService: UserService, public route: ActivatedRoute) {}

  /**
   * All existing menu items
   */
  public menuItems: MenuItem[] = AllMenu.MENU_ITEMS;
  
  ngOnInit(): void {
    this.userService.sharedUsername.subscribe(username => this.username = username);
         
    /**
     * Subscribe to userservice event wich emits allowed menu items  (String[] bieng menuLinks values)
     */
    this.userService.userLoggedInEvent.subscribe((data:string[]) => {
      this.updateMenu( data );

      this.restricted = localStorage.getItem('restricted')=='true';
    });

  }

  /**
   * Updates the available menu items, accordingly to allowed emitted by user service
   */
  public updateMenu( allowed: string[]): void {

    this.logged = true;
    
    this.menuItems =this.menuItems.filter(item=>{
      return allowed.includes(item.menuLink);
    })
  }


  /* Clear the storage on Logout */
  public onLogOut() : void {
    this.logged = false;
    this.clear();
  }


  public clear() : void {
    localStorage.removeItem("userToken");
  }


  
}
